/**
 * `/teacher/courses` — read-only list of mock courses for the current
 * teacher. Empty / loading / error states all wired up.
 */

import { useApiClient } from '../../api/ApiClientProvider';
import { useFetch } from '../../api/useFetch';
import { useSession } from '../../auth/SessionProvider';
import {
  EmptyState,
  ErrorState,
  LoadingState,
} from '../../components/States';

export function Courses() {
  const client = useApiClient();
  const { session } = useSession();
  const token = session?.token ?? '';
  const state = useFetch(() => client.listCourses(token), [client, token]);

  if (state.status === 'loading') {
    return <LoadingState label="Loading courses…" />;
  }
  if (state.status === 'error') {
    return <ErrorState error={state.error} />;
  }
  if (state.data.length === 0) {
    return (
      <EmptyState
        title="No courses yet"
        description="Run a mock LMS sync from the worker to seed sample courses."
      />
    );
  }

  return (
    <section className="page" data-testid="teacher-courses">
      <header className="page__header">
        <h1>Courses</h1>
        <p className="muted">Read-only mock LMS data. No real student records.</p>
      </header>

      <table className="table" aria-label="Courses">
        <thead>
          <tr>
            <th scope="col">Course</th>
            <th scope="col">Code</th>
            <th scope="col">Term</th>
            <th scope="col">Students</th>
          </tr>
        </thead>
        <tbody>
          {state.data.map((course) => (
            <tr key={course.id} data-testid="course-row">
              <td>{course.name}</td>
              <td>
                <code>{course.code}</code>
              </td>
              <td>{course.termName}</td>
              <td>{course.studentCount}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
